"use client";

import { useEffect } from "react";
import { SessionManager } from "@/lib/session/SessionManager";

interface SearchPageSessionWrapperProps {
  children: React.ReactNode;
  city: string;
  state: string;
}

/**
 * Client component wrapper for search pages to manage sessions
 * This ensures search session is created/continued on page load
 */
export default function SearchPageSessionWrapper({
  children,
  city,
  state,
}: SearchPageSessionWrapperProps) {
  useEffect(() => {
    // Create or continue search session when page loads
    const sessionId = SessionManager.startSearchSession(city, state);
    console.log(
      `🔍 Search page loaded: ${city}--${state} | Session: ${sessionId}`
    );
  }, [city, state]);

  return <>{children}</>;
}
